import { render, staticRenderFns } from "./VipPro.vue?vue&type=template&id=d28f29b8"
import script from "./VipPro.vue?vue&type=script&lang=js"
export * from "./VipPro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports